
export function copyUrlToClipboard()
{
	const shareUrlLinks = document.querySelectorAll('[data-clipboard-url]');

	if (shareUrlLinks.length > 0)
	{
		shareUrlLinks.forEach((shareUrlLink) =>
		{
			shareUrlLink.setAttribute('data-no-swup', true);

			shareUrlLink.addEventListener('click', (event) =>
			{
				event.preventDefault();
				const el = document.createElement('textarea');
				el.setAttribute('readonly', '');
				el.style.position = 'absolute';
				el.style.left = '-9999px';
				el.value = shareUrlLink.getAttribute('data-clipboard-url');
				document.body.appendChild(el);
				el.select();
				document.execCommand('copy');
				document.body.removeChild(el);

				shareUrlLink.classList.add('copy-url-to-clipboard--copied');

				setTimeout(() =>
				{
					shareUrlLink.classList.remove('copy-url-to-clipboard--copied');
				}, 2500);
			});
		});
	}
}



// WEBPACK FOOTER //
// ./scripts/modules/copyUrlToClipboard.js